import 'leaflet/dist/leaflet.css';
import {MapContainer, TileLayer} from 'react-leaflet';
import RoutingMachine from './RoutingMachine';
import {Order} from 'types';
import {LatLngExpression} from 'leaflet';

type Props = {
  display: boolean;
  orders: Order[];
  markerClick?: (key: string) => void;
  polylines?: LatLngExpression[];
  start_location: {
    name: string;
    lat: number;
    lng: number;
  };
  end_location: {
    name: string;
    lat: number;
    lng: number;
  };
  openedPopup?: {
    index: number;
    open: boolean;
    refKey: string;
  };
  driver_id?: number;
  shouldDrawRoute?: boolean;
};

function NewMap({
  display,
  orders,
  start_location,
  end_location,
  polylines,
  markerClick,
  openedPopup,
  driver_id,
  shouldDrawRoute,
}: Props) {
  return (
    <MapContainer
      center={[40.7128, -74.006]}
      // style={{height: 'calc(100vh - 164px)'}}
      style={{height: '100%'}}
      zoom={11}
    >
      <TileLayer
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
      />
      <RoutingMachine
        shouldDrawRoute={shouldDrawRoute}
        driver_id={driver_id}
        polylines={polylines}
        openedPopup={openedPopup}
        markerClick={markerClick}
        start_location={start_location}
        end_location={end_location}
        orders={orders}
        display={display}
      />
    </MapContainer>
  );
}

export default NewMap;
